<template>
<main>
  <div class="template-header">
    <margin-title :title="title" :subtitle="subtitle" />
    <button class="button is-primary" v-if="headerButton && getWidth !== 'xs'" @click="onButton">
      {{ headerButton }}
    </button>
  </div>
  <div v-if="getWidth === 'xs'">
    <button class="button is-primary" v-if="headerButton" @click="onButton">
      {{ headerButton }}
    </button>
  </div>
  <div class="m-b-32">
    <slot></slot>
  </div>
</main>
</template>

<script>
import MarginTitle from '@/components/margin-title'

export default {
  components: { MarginTitle },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Admin'
    },
    subtitle: {
      type: String,
      required: true
    },
    headerButton: {
      type: String,
      default: null
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  data () {
    return {
      windowWidth: 0
    }
  },
  computed: {
    getWidth () {
      if (this.windowWidth <= 550) {
        return 'xs'
      }
      return 'lg'
    }
  },
  methods: {
    onButton () {
      this.$emit('onButtonClicked')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.template-header {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 24px;
  }
  @media screen and (max-width: $tablet) {
    .template-header {
      margin-top: 0px !important;
    }
    .button {

    }
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/admin-sub.vue